import React from 'react';
import { Input } from 'formik-antd';
import { Row, Col } from 'antd';
import cx from 'classnames';

import Radio from 'components/formik/Radio';
import FormItem from 'components/formik/FormItem';
import styles from './QuestionnaireElement.module.less';

type Props = {
  label: string;
  fieldPrefix: string;
};

export default function QuestionnaireElement(props: Props) {
  const { label, fieldPrefix } = props;

  return (
    <Row gutter={[4, 4]} align="middle">
      <Col xs={24} md={12}>
        <span>{label}</span>
      </Col>

      <Col xs={24} md={4}>
        <FormItem
          className={cx('inline-radio', styles.formItem)}
          name={`${fieldPrefix}.closedQuestion`}
        >
          <Radio.Group
            className="radio"
            name={`${fieldPrefix}.closedQuestion`}
            options={[
              { label: 'Yes', value: true },
              { label: 'No', value: false },
            ]}
          />
        </FormItem>
      </Col>

      <Col xs={24} md={8}>
        <FormItem name={`${fieldPrefix}.comment`} className={styles.formItem}>
          <Input.TextArea
            name={`${fieldPrefix}.comment`}
            placeholder="Enter comment"
            autoComplete="off"
          />
        </FormItem>
      </Col>
    </Row>
  );
}
